import React from "react"
import { Col, Row, Form } from "react-bootstrap"
import { Field } from "formik"
import {
  updateCategoryClaimData,
  formIsValidUpdate,
  updatePoliceReportMandatory,
} from "../../../../Redux/WindscreenClaim/actions"
import { useDispatch, useSelector, shallowEqual } from "react-redux"
import * as Constants from "../../../../common/constants"

function FormNatureOfDamage(props) {
  const {
    textDesc,
    form,
    field,
    maxLength,
    coverageCategory,
    coverageCode,
    formIsValid,
    formName,
  } = props

  const dispatch = useDispatch()
  const claimData = useSelector(state => state.claimData, shallowEqual)

  const handleTextChange = (event, error, category, coverageCode) => {
    const inputName = event.target.name
    const inputValue = event.target.value

    dispatch(
      updateCategoryClaimData(
        coverageCategory,
        coverageCode,
        inputName,
        inputValue
      )
    )
    dispatch(formIsValidUpdate(formName, formIsValid))

    form.resetForm()
    form.validateForm()
  }

  const inputErrorMessage = () => {
    return (
      <span
        className={
          "InputError " +
          (claimData["claimInfo"]["policyInfo"].natureOfDamage === textDesc
            ? ""
            : "hide")
        }
      >
        {field.value.trim() === "" ? Constants.otherNatureOfDamageErrorMsg : ""}
      </span>
    )
  }

  const handleNatureOfDamageChange = (category, details, value) => {
    dispatch(
      updateCategoryClaimData(category, details, "natureOfDamage", value)
    )

    if (value === Constants.descOfDamageNeedPoliceReportUplaod) {
      dispatch(updatePoliceReportMandatory(true))
    } else {
      dispatch(updatePoliceReportMandatory(false))
    }
  }

  return (
    <Form.Group>
      <Row>
        <Col
          xs={12}
          md={12}
          className={"textforinput marginTop10px cursorPointer minHeight50px"}
          onClick={() =>
            handleNatureOfDamageChange(coverageCategory, coverageCode, textDesc)
          }
        >
          <div
            className={
              "FieldDescRadioButton " +
              (claimData["claimInfo"]["policyInfo"].natureOfDamage === textDesc
                ? "tick"
                : "")
            }
          ></div>
          <p>{textDesc}</p>
        </Col>

        <Col xs={12} md={12} className="marginTop10px">
          <Field
            name={field.name}
            className={
              "inputbox " +
              (claimData["claimInfo"]["policyInfo"].natureOfDamage === textDesc
                ? ""
                : "hide")
            }
            type="text"
            onChange={event => {
              form.handleChange(event)
            }}
            onBlur={event => {
              form.handleBlur(event)
              field.onBlur(event)
              handleTextChange(
                event,
                form.errors,
                coverageCategory,
                coverageCode
              )
            }}
            maxLength={maxLength}
            autoComplete="new-password"
            value={field.value ? field.value : ""}
          />

          {inputErrorMessage()}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormNatureOfDamage
